import { ca } from '@cian/analytics';
import { IRecommendationNewbuildingInfrastructure } from '../../../types/map';

export function trackSimilarNewbuildingInfrastructureClick(
  newbuildings: IRecommendationNewbuildingInfrastructure[],
  blockType: string,
) {
  const modelVersion = newbuildings[0] && newbuildings[0].modelVersion;

  ca('eventSite', {
    action: 'click_object_type',
    category: 'Infrastructure',
    label: 'similar_newbuilding',
    modelVersion,
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        newbuildingId: newbuildings.map(({ newbuildingId }) => newbuildingId),
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
